import { Cohorts } from '@platform/client';
import { CohortBaseDetail } from '@platform/client/schemas';
import Skeleton from 'react-loading-skeleton';
import { PanelFooter } from './PanelFooter';
import { TimelineSection } from './TimelineSection';

const CohortPanel = () => {
  const { data: myCohortResponse, isLoading, isError } = Cohorts.useGetUserMyCohortPreview();

  if (isLoading) {
    return <Skeleton height={360} width='100%' />;
  }
  if (isError || !myCohortResponse) {
    return (
      <div className='w-full border border-gray-100 rounded-xl'>Error loading cohort data</div>
    );
  }
  return (
    <div className='w-full border border-gray-100 rounded-xl overflow-hidden shadow-xs'>
      <CohortPanelHeader cohortData={myCohortResponse.cohort} />
      <div className='pt-[18px] pb-3.5 px-[22px]'>
        <p className='text-base font-bold mb-5'>Your Progress</p>
        <TimelineSection
          cohortData={myCohortResponse.cohort}
          userProgress={myCohortResponse.currentProgress}
          projectHubUrl={myCohortResponse.projectHubUrl}
        />
      </div>
      <PanelFooter members={myCohortResponse.members} totalCount={myCohortResponse.totalCount} />
    </div>
  );
};

const CohortPanelHeader = ({ cohortData }: { cohortData: CohortBaseDetail }) => {
  return (
    <div className='bg-linear-to-r from-brand-500 to-brand-600 text-white py-3.5 px-[1.25rem]'>
      <p className='text-base font-bold'>{cohortData.name}</p>
      {cohortData.duration && cohortData.timeCommitment && (
        <p className='text-xs'>
          {cohortData.duration} · {cohortData.timeCommitment}
        </p>
      )}
    </div>
  );
};

export default CohortPanel;
